import { z } from 'zod';
import { AmountPart, ProductConsumptionMoment, ProductPricing } from '@mews-commander/data-access';
import { ProductChargingMode, ProductPostingMode } from '@mews/enums';

const commonPricingSchema = z.object({
    taxRates: z.record(z.string().nullish()),
    consumptionMoment: z.nativeEnum(ProductConsumptionMoment),
});

export const productPricingSchema = commonPricingSchema.extend({
    pricing: z.discriminatedUnion('type', [
        z.object({
            type: z.literal(ProductPricing.Absolute),
            amount: z.number(),
            currency: z.string(),
            charging: z.nativeEnum(ProductChargingMode),
        }),
        z.object({
            type: z.literal(ProductPricing.Relative),
            percentage: z.number(),
            value: z.nativeEnum(AmountPart),
            products: z.array(z.string()).nonempty(),
            charging: z.nativeEnum(ProductPostingMode),
        }),
    ]),
    taxExemptionReasonCode: z.string().nullish(),
    taxExemptionLegalReference: z.string().nullish(),
});

export const allowancePricingSchema = commonPricingSchema.extend({
    pricing: z.object({
        creditAmount: z
            .number()
            .optional()
            .transform((v) => (v === undefined ? 0 : v)),
        price: z.number().min(1),
        currency: z.string(),
        charging: z.nativeEnum(ProductChargingMode),
    }),
});
